<template>
  <div>
    <!-- 顶部 -->
    <detailHeader />
    <div class="orderPreviewPage">
      <!-- 订单详情 -->
      <div class="orderDetail">
        <!-- 订单列表 -->
        <div class="table">
          <!-- 列表头部 -->
          <ol>

            <li class="flex05">NO</li>
             <!-- 選択 -->
            <li class="flex05">
              {{ $t("message.sentaku") }}
            </li>
            <!-- 写真 -->
            <li class="flex05" v-if="type">
              {{ $t("message.photo") }}
            </li>
            <!-- 管理番号 -->
            <li class="flex05">
              {{ $t("message.managementDesignation") }}
            </li>
            <!-- 商品属性 -->
            <li class="flex1">
              {{ $t("message.commodityAttribute") }}
            </li>
            <!-- 业务商品属性 -->
            <li class="flex1">
              {{ $t("message.businessEditAttributes") }}
            </li>

            <!-- 下单数 -->
            <li class="flex05">
              {{ $t("message.lowerSingular") }}
            </li>
            <!-- 单价.元 -->
            <li class="flex05">
              {{ $t("message.unitPriceYuan") }}
            </li>
            <!-- 小计(元) -->
            <li class="flex05">
              {{ $t("message.subtotalYuan") }}
            </li>
            <!-- 附加服务 -->
            <li class="flex1">
              {{ $t("message.additionalServices") }}
            </li>
            <!-- 标签设置 -->
            <li class="flex1">
              {{ $t("message.labelSetting") }}
            </li>
            <!-- 备注栏 -->
            <li class="flex1">
              {{ $t("message.remarksField") }}
            </li>
          </ol>
          <!-- list -->
          <div v-for="(item, index) in orderDetail" :key="item.No" class="goodsGroup">
            <ul>

            <!-- 商品管理预览即使没有辅料，也保留展开入口查看下单要求。 -->
            <li class="flex05 noCell" :class="{ productPreviewNoCell: type === 'productManagementV2' }">
              <div v-if="item.is_material" class="materialMarkTip">
                <MaterialMarkTip :material-id="item.material_id" :user-id="user_id" :detail="item.material_detail" />
              </div>
              <span class="noNumber">{{ item.No }}</span>
              <el-button v-if="type === 'productManagementV2' || hasBoundMaterial(item)" class="materialToggle" type="text" size="mini"
                @click="toggleMaterial(item)">
                {{ item.materialExpanded ? $t("message.collapse") : $t("message.expand") }}
                <i :class="item.materialExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </el-button>
            </li>
             <!-- 選択 -->
            <li class="flex05 orderChecked">
              <label>
                <el-checkbox v-model="item.checked" @change="theRadio"></el-checkbox>
              </label>
            </li>
            <!-- 写真 -->
            <li class="flex05">
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                <a :href="item.link" slot="reference" target="_blank">
                  <el-image :src="item.pic" style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </li>
            <!-- 管理番号 -->
            <li class="flex05" v-if="type">
              <el-input size="small" v-model="item.for_sn"></el-input>
            </li>
            <!-- 商品属性 -->
            <li class="flex1 rowAndCenterAndCenter">
              <div class="attributeEditContainer">
                <div class="attribute">
                  <el-tooltip placement="bottom" style="height:60px">
                    <div slot="content">
                      <div class="row" v-for="(itemDetail, itemIndex) in item.detail" :key="itemIndex"
                        style="margin-bottom: 5px">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                    <div>
                      <div class="row" v-for="(itemDetail, itemIndex) in item.detail" :key="itemIndex">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                  </el-tooltip>
                </div>
                <i class="el-icon-edit" @click="attributeEdit(item, index, 'detail')"></i>
              </div>
            </li>
            <!-- 业务商品属性 -->
            <li class="flex1 rowAndCenterAndCenter">
              <div class="attributeEditContainer">
                <div class="attribute">
                  <el-tooltip placement="bottom" style="height:60px">
                    <div slot="content">
                      <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                        style="margin-bottom: 5px">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                    <div>
                      <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                  </el-tooltip>
                </div>
                <i class="el-icon-edit" @click="attributeEdit(item, index, 'detail_y')"></i>
              </div>
            </li>
            <!-- 下单数 -->
            <li class="flex05 rowAndCenterAndCenter goodsNum">
              <el-input v-model.number="item.num" style="width: 80px" type="number" @input="numTrunc(item)"
                @wheel.native.prevent="stopScroll($event)" @keydown.native="newChannelInputLimit" />
            </li>
            <!-- 单价.元 -->
            <li class="flex05">
              {{ item.price }}
            </li>
            <!-- 小计(元) -->
            <li class="flex05 rowAndCenterAndCenter subtotal">
              <div>{{ item.total }}</div>
              <!--详细-->
              <el-popover placement="bottom" width="200" trigger="click">
                <div style="padding:10px">
                  <div class="row" style="margin-bottom: 10px;">
                    商品金額.元 <span style="float: right;">{{ item.goodsTotal }}</span>
                  </div>
                  <div class="row" style="margin-bottom: 10px;">
                    手续费({{ item.service_rate * 100 }}%).元 <span style="float: right;">{{ item.service_price }}</span>
                  </div>
                  <div class="row">
                    附加服务费.元 <span style="float: right;">{{ ceil(item.optionPrice) }}</span>
                  </div>
                </div>

                <div class="detail" slot="reference">{{ $t("message.detail") }}</div>
              </el-popover>
            </li>
            <!-- 附加服务 -->
            <li class="flex1">
              <div class="tagEditContainer">
                <div class="option">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex"
                        style="margin-bottom: 3px">
                        <p v-if="opti.num > 0 && opti.checked">
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                    <div style="height: 70px">
                      <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex">
                        <p v-if="opti.num > 0 && opti.checked">
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
                <i class="el-icon-edit" @click="optionEdit(item, index)"></i>
              </div>
            </li>
            <!-- 标签设置 -->
            <li class="flex1">
              <div class="tagEditContainer">
                <div class="tags">
                  <div v-for="(itemDetail, itemIndex) in item.order_detail_tag" :key="itemIndex">
                    <div class="row" style="margin-bottom: 5px">
                      类别：{{ itemDetail.type }}
                    </div>
                    <div class="row" style="margin-bottom: 5px">
                      标签号：{{ itemDetail.no }}
                    </div>
                    <div class="row" style="margin-bottom: 5px">
                      商品码：{{ itemDetail.goods_no }}
                    </div>
                  </div>
                  <i class="el-icon-edit" @click="editTag(item, index)"></i>
                </div>
              </div>
            </li>
            <!-- 备注栏 -->
            <li class="flex1 clientRemark rowAndCenterAndCenter">
              <el-input resize="none" v-model="item.client_remark" @input="updateClientRemark" type="textarea" />
            </li>
            </ul>
            <!-- 左侧辅料可横向滚动；右侧三项要求来自商品管理，仅供查看。 -->
            <div v-if="type === 'productManagementV2'" v-show="item.materialExpanded" class="productPreviewDetails">
              <div class="productPreviewMaterial">
                <MaterialInfo :list="item.material_list" :order-quantity="item.num" :user-id="user_id"
                  :editable="isAuth(757)" :removable="isAuth(757)"
                  @update-consume="updateMaterialConsume(item, $event)" @remove="removeMaterial(item, $event)" />
              </div>
              <div class="productPreviewRemarks">
                <div class="remarkItem">
                  <label>{{ $t('message.productV2PurchaseRequirement') }}</label>
                  <el-input :value="item.purchase_remark" type="textarea" :rows="4" resize="none" readonly />
                </div>
                <div class="remarkItem">
                  <label>{{ $t('message.productV2InspectionRequirement') }}</label>
                  <el-input :value="item.inspect_remark" type="textarea" :rows="4" resize="none" readonly />
                </div>
                <div class="remarkItem">
                  <label>{{ $t('message.productV2AllocationRequirement') }}</label>
                  <el-input :value="item.delivery_remark" type="textarea" :rows="4" resize="none" readonly />
                </div>
              </div>
            </div>
            <MaterialInfo v-else v-show="item.materialExpanded && hasBoundMaterial(item)" :list="item.material_list"
              :order-quantity="item.num" :user-id="user_id" :editable="isAuth(757)" :removable="isAuth(757)"
              @update-consume="updateMaterialConsume(item, $event)" @remove="removeMaterial(item, $event)" />
          </div>
        </div>
      </div>
      <!-- 价格、物流、文件、备注 -->
      <orderPrice :orderPriceInfo="orderPriceInfo" :selectOptionList="orderSelectOptionList" ref="orderPrice" />
      <!-- 操作 -->
      <div class="operate">
        <!--左边按钮及商品数   -->
        <div class="flexAndCenter">
          <!--全选  -->
          <el-checkbox v-model="checked" style="margin-right: 30px" @change="allChecked">{{ $t("message.allChecked") }}
          </el-checkbox>
          <!-- 削除 -->
          <el-button size="mini" type="primary" class="dark" @click="deleteGoods">{{ $t("message.delete") }}
          </el-button>
          <!-- 直接追加商品 -->
          <el-button size="mini" type="success" @click="$refs.directAddition.dialogVisible = true">{{
            $t("message.directAdditionalGoods") }}
          </el-button>
          <!-- 购物车追加 -->
          <el-button size="mini" class="secondary" @click="shoppingCartAdd">{{ $t("message.shoppingCartAdd") }}
          </el-button>
          <!-- 商品库追加 -->
          <el-button size="mini" class="backgroundFFA21D" @click="inventoryAddition">{{ $t("message.inventoryAddition")
          }}
          </el-button>

          <el-tooltip v-if="isAuth(670)" :disabled="!markMaterialDisabled"
            :content="$t('message.boundMaterialCannotMark')" placement="top">
            <span class="materialAction">
              <el-button size="mini" class="secondary" :disabled="markMaterialDisabled" @click="markAsMaterial">{{
                $t("message.markAsMaterial") }}</el-button>
            </span>
          </el-tooltip>
          <el-button v-if="isAuth(670)" size="mini" type="primary" class="dark" @click="cancelMaterialMark">{{
            $t("message.cancelMaterialMark") }}
          </el-button>
          <el-tooltip v-if="isAuth(757)" :disabled="!bindMaterialDisabled"
            :content="$t('message.markedMaterialCannotBind')" placement="top">
            <span class="materialAction">
              <el-button size="mini" class="secondary" :disabled="bindMaterialDisabled" @click="bindMaterialUsage">{{
                $t("message.bindMaterialUsage") }}</el-button>
            </span>
          </el-tooltip>
          <!--         商品数-->
          <div style="margin-left: 39px">
            {{ $t("message.numberOfGoods") }}：{{
              orderPriceInfo.goodsTotalNum
            }}
          </div>
        </div>
        <!-- 右边按钮 -->
        <!--        商品金額-->
        <div class="flexAndCenter">
          <div>{{ $t("message.amountOfGoods") }}：</div>
          <div class="goodsPriceText">
            {{ Number(orderPriceInfo.goodsTotalRmbPrice).toFixed(2) }}￥
          </div>
          <!--元 円-->
          <div>
            （1{{ $t("message.unit") }}={{ $store.state.rate
            }}{{ $t("message.Yen") }}）
          </div>
          <!--元 -->
          <div>
            {{ orderPriceInfo.goodsTotalYenPrice }} {{ $t("message.Yen") }}
          </div>
          <!-- 提出订单 -->
          <el-button type="primary" @click="submitOrder" style="margin-left: 30px">{{ $t("message.submitOrder") }}
          </el-button>
        </div>
      </div>
      <!-- 直接追加商品 -->
      <directAddition @getDirectAdditionOrder="getDirectAdditionOrder" ref="directAddition" />
      <!-- 修改属性 -->
      <attribute v-if="attributeDialogVisible" :detail="itemDetail" />
      <!-- option -->
      <options v-if="optionsDialogVisible" :detail="itemDetail" :status="status" />
      <!-- 商品库追加 -->
      <commodityWarehouse v-if="commodityWarehouseDialogVisible" />
      <!-- 购物车追加 -->
      <shoppingCart v-if="shoppingCartDialogVisible" />
      <!-- 标签设置 -->
      <orderTag v-if="tagDialogVisible" :order_detail_tag="order_detail_tag" />
      <!-- 选择辅料并标识商品 -->
      <MaterialSelectDialog ref="materialSelectDialog" :user-id="user_id" :title="$t('message.confirmMarkAsMaterial')"
        @confirm="confirmMarkAsMaterial" />
      <!-- 多选辅料、编辑消耗数并绑定至勾选商品 -->
      <MaterialBindDialog ref="materialBindDialog" :user-id="user_id" @confirm="confirmBindMaterial" />
    </div>
  </div>
</template>
<script>
import options from "./components/options";
import attribute from "@/views/orderDetail/components/attribute";
import orderPrice from "./components/orderPrice";
import directAddition from "./components/directAddition";
import commodityWarehouse from "./components/commodityWarehouse";
import shoppingCart from "./components/shoppingCart";
import orderTag from "./components/orderTag";
import detailHeader from "@/components/header/detailHeader";
import MaterialInfo from "@/components/common/materialInfo";
import MaterialMarkTip from "@/components/common/materialMarkTip";
import MaterialSelectDialog from "@/components/common/materialSelectDialog";
import MaterialBindDialog from "@/components/common/materialBindDialog";
import { deepClone } from "@/utlis/utlis";

export default {
  components: {
    options,
    attribute,
    orderPrice,
    directAddition,
    detailHeader,
    commodityWarehouse,
    shoppingCart,
    orderTag,
    MaterialInfo,
    MaterialMarkTip,
    MaterialSelectDialog,
    MaterialBindDialog,
  },
  metaInfo() {
    return {
      title: '帮客户提订单',
    };
  },
  data() {
    return {
      type: this.$route.query.type, // Excel下单用的
      user_id: this.$route.query.userID,
      attributeDialogVisible: false,
      itemDetail: {},
      orderDetail: [],
      i: null,
      optionList: [],
      orderSelectOptionList: [],
      orderPriceInfo: {
        goodsTotalRmbPrice: 0, //商品金额总计人民币
        goodsTotalYenPrice: 0, //商品金额总计日元
        RMBTotalPrice: 0, //总计金额人民币
        yenTotalPrice: 0, //总计金额日元
        optionTotalPrice: 0, //附加服务金额
        goodsTotalNum: 0, //商品数
        serviceTotalNum: 0, //手续费
      },
      status: 20,
      order_sn: "",
      optionsDialogVisible: false,
      dialogVisible: false,
      commodityWarehouseDialogVisible: false,
      shoppingCartDialogVisible: false,
      tagDialogVisible: false,
      order_detail_tag: {},
      checked: false,
      typeDetail: null,//再来一单使用
      detailType: '',//修改属性类型
      markMaterialGoods: [],
      bindMaterialGoods: [],
    };
  },
  computed: {
    // 已绑定辅料的勾选商品不能再标识为辅料
    markMaterialDisabled() {
      return this.orderDetail.some(item => item.checked && this.hasBoundMaterial(item))
    },
    // 仅当勾选商品全部已是辅料标识时禁用；仍有普通番时可继续绑定辅料使用
    bindMaterialDisabled() {
      const checked = this.orderDetail.filter(item => item.checked)
      if (!checked.length) return false
      return checked.every(item => item.is_material)
    }
  },
  created() {
    // 商品库添加
    let ids = this.$route.query.ids;
    if (ids) {
      this.previewAddBeInventory();
    }
    // option 选择
    this.$api.siteConfiguration.optionList({ user_id: this.$route.query.userID }).then((res) => {
      res.data.forEach((item) => {
        item.total = 0;
      });
      this.optionList = res.data;
    });
  },
  mounted() {

    // Excel下单用的
    if (this.type) {

      this.getDirectAdditionOrder(JSON.parse(window.name))
      console.log(JSON.parse(window.name));


    }
  },
  methods: {
    //商品库提出订单预览
    previewAddBeInventory() {
      let datas = {
        user_id: this.user_id,
        overlook_inventory_ids: [-1],
      };
      let ids = this.$route.query.ids.split(",");
      this.$api.clienteleApi.previewAddBeInventory(datas).then((res) => {
        ids.forEach((id, i) => {
          res.data.forEach((item) => {
            item.goods.forEach((items) => {
              if (items.id == id) {
                items.num = 1;
                items.No = i + 1;
                items.fromPlatform = items.shop_type;
                items.goodsId = items.goods_id;
                items.checked = false;
                items.tagList = [];
                items.client_remark = items.note
                items.checked = false;
                items.order_detail_tag = items.inventory_tag
                this.initMaterialState(items)

                // items.goodsInfo = items.goods_data.goodsInfo;
                this.orderDetail.push(items);

              }
            });
          });
        });

        this.commodityTotal();
      });
    },
    // 初始化商品行辅料状态，展示字段沿用商品维护的绑定辅料结构
    initMaterialState(item) {
      if (item.materialExpanded === undefined) {
        // 商品管理入口默认展开；其他下单入口沿用原有收起状态。
        this.$set(item, 'materialExpanded', this.type === 'productManagementV2')
      }
      // 严格按 is_material 判断辅料标识，避免把绑定辅料误判成标识辅料
      let isMaterial = false
      if (item.is_material === undefined || item.is_material === null || item.is_material === '') {
        isMaterial = Boolean(item.material_id)
      } else {
        isMaterial = Number(item.is_material) === 1 || item.is_material === true
      }
      this.$set(item, 'is_material', isMaterial)
      if (isMaterial) {
        const materialId = item.material_id || (item.material && item.material.id) || (item.material_detail && item.material_detail.id) || ''
        if (materialId) this.$set(item, 'material_id', materialId)
      }
      if (!Array.isArray(item.material_list)) {
        this.$set(item, 'material_list', this.getProductMaterialList(item))
      }
    },
    // 将商品已绑定辅料转换为公共组件使用的扁平结构
    getProductMaterialList(item) {
      // 再来一单等场景会直接带上 material_bind
      if (Array.isArray(item.material_bind) && item.material_bind.length) {
        return item.material_bind.map(binding => {
          const material = binding.material_detail || binding.material || {}
          const materialType = material.type || {}
          return {
            // 复用辅料卡片查询库位时，只能传辅料主档 ID。
            material_id: binding.material_id || material.id,
            name_trans: material.name_trans || binding.name_trans,
            main_image: material.main_image || binding.main_image,
            material_stock_num: material.material_stock_num || binding.material_stock_num || 0,
            type_name: materialType.name || material.type_name || binding.type_name,
            consume: binding.consume !== undefined && binding.consume !== null ? binding.consume : 1
          }
        })
      }
      if (Array.isArray(item.material)) {
        return deepClone(item.material)
      }
      return (item.client_product_material || []).map(binding => {
        const material = binding.material_detail || binding.material || {}
        const materialType = material.type || {}
        return {
          material_id: binding.material_id || material.id,
          name_trans: material.name_trans || binding.name_trans,
          main_image: material.main_image || binding.main_image,
          material_stock_num: material.material_stock_num || binding.material_stock_num || 0,
          type_name: materialType.name || material.type_name || binding.type_name,
          consume: binding.consume !== undefined && binding.consume !== null ? binding.consume : 1
        }
      })
    },
    // 获取当前勾选商品，辅料批量操作统一使用
    getCheckedGoods() {
      const list = this.orderDetail.filter(item => item.checked)
      if (!list.length) {
        this.$message.error(this.$t("message.selectableOperationalList"))
      }
      return list
    },
    // 批量展开或收起辅料信息
    materialOperation() {
      const list = this.getCheckedGoods()
      if (!list.length) return
      const expanded = !list.every(item => item.materialExpanded)
      list.forEach(item => {
        this.initMaterialState(item)
        item.materialExpanded = expanded
      })
    },
    // 判断订单商品是否已经绑定辅料使用
    hasBoundMaterial(item) {
      if (Array.isArray(item.material_list)) return item.material_list.length > 0
      return this.getProductMaterialList(item).length > 0
    },
    // 打开辅料列表，选择后再标识勾选商品
    markAsMaterial() {
      if (!this.isAuth(670)) return
      const list = this.getCheckedGoods()
      if (!list.length) return
      if (list.some(item => this.hasBoundMaterial(item))) {
        this.$message.error(this.$t('message.boundMaterialCannotMark'))
        return
      }
      this.markMaterialGoods = list
      const selectedList = list.length === 1 && list[0].material_detail ? [list[0].material_detail] : []
      this.$refs.materialSelectDialog.open(selectedList)
    },
    // 将弹窗选中的辅料写入本次勾选商品
    confirmMarkAsMaterial(list) {
      if (!this.isAuth(670)) return
      const material = list[0]
      if (!material) return
      if (this.markMaterialGoods.some(item => this.hasBoundMaterial(item))) {
        this.$message.error(this.$t('message.boundMaterialCannotMark'))
        return
      }
      this.markMaterialGoods.forEach(item => {
        this.$set(item, 'is_material', true)
        this.$set(item, 'material_id', material.id)
        this.$set(item, 'material_detail', material)
      })
      this.markMaterialGoods = []
    },
    // 取消勾选商品的辅料标识及关联辅料
    cancelMaterialMark() {
      if (!this.isAuth(670)) return
      const list = this.getCheckedGoods()
      if (!list.length) return
      this.$confirm(
        this.$t('message.confirmCancelMaterialMark'),
        this.$t('message.prompt'),
        {
          confirmButtonText: this.$t('message.ok'),
          cancelButtonText: this.$t('message.cancel'),
          type: 'warning'
        }
      ).then(() => {
        list.forEach(item => {
          this.$set(item, 'is_material', false)
          this.$set(item, 'material_id', '')
          this.$set(item, 'material_detail', null)
        })
      }).catch(() => {})
    },
    // 打开绑定辅料弹窗；单个商品回显现有绑定，多商品从空选择开始
    bindMaterialUsage() {
      if (!this.isAuth(757)) return
      const checked = this.getCheckedGoods()
      if (!checked.length) return
      // 已标识为辅料的番跳过，只对普通商品绑定辅料使用
      const list = checked.filter(item => !item.is_material)
      if (!list.length) {
        this.$message.error(this.$t('message.markedMaterialCannotBind'))
        return
      }
      list.forEach(item => {
        this.initMaterialState(item)
      })
      this.bindMaterialGoods = list
      const selectedList = list.length === 1 ? list[0].material_list : []
      this.$refs.materialBindDialog.open(selectedList)
    },
    // 将弹窗所选完整辅料列表及消耗数写入所有勾选商品
    confirmBindMaterial(selectedList) {
      if (!this.isAuth(757)) return
      if (this.bindMaterialGoods.some(item => item.is_material)) {
        this.$message.error(this.$t('message.markedMaterialCannotBind'))
        return
      }
      this.bindMaterialGoods.forEach(item => {
        this.$set(item, 'material_list', deepClone(selectedList))
        this.$set(item, 'materialExpanded', true)
      })
      this.bindMaterialGoods = []
    },
    // 提交接口前再次校验辅料标识与辅料绑定互斥
    validateMaterialRelation() {
      const hasConflict = this.orderDetail.some(item => item.is_material && this.hasBoundMaterial(item))
      if (hasConflict) {
        this.$message.error(this.$t('message.materialRelationConflict'))
        return false
      }
      return true
    },
    // 单行展开或收起辅料信息
    toggleMaterial(item) {
      this.initMaterialState(item)
      item.materialExpanded = !item.materialExpanded
    },
    // 更新辅料消耗点数
    updateMaterialConsume(item, data) {
      if (!this.isAuth(757)) return
      this.$set(item.material_list[data.index], 'consume', data.consume)
    },
    // 删除当前商品的一条辅料使用信息
    removeMaterial(item, index) {
      if (!this.isAuth(757)) return
      item.material_list.splice(index, 1)
    },
    //全选
    allChecked() {
      this.orderDetail.forEach((item) => {
        item.checked = this.checked;
      });
    },
    //删除商品
    deleteGoods() {
      if (this.orderDetail.length > 0) {
        let list = [];
        this.orderDetail.forEach((item, index) => {
          if (item.checked) {
            list.push(item.No);
          }
        });
        list.forEach((item) => {
          this.deleteItem(item);
          this.$forceUpdate();
        });
        this.commodityTotal();
      }
    },
    //删除单个
    deleteItem(No) {
      console.log(No);
      for (let i = 0; i < this.orderDetail.length; i++) {
        if (this.orderDetail[i].No == No) {
          this.orderDetail.splice(i, 1);
          break;
        }
      }
    },
    // 单选
    theRadio() {
      this.checked = this.orderDetail.every((item) => item.checked);
      this.$forceUpdate();
    },
    //获取直接添加商品的数据
    getDirectAdditionOrder(msg) {
      this.typeDetail = msg
      msg.orderList.forEach((item) => {
        item.checked = false;
        item.tagList = [];
        // item.option = [];
        item.checked = false;
        if (item.order_detail_tag == false) {
          item.order_detail_tag = []
        }
        this.orderDetail.length === 0
          ? (item.No = 1)
          : (item.No = this.orderDetail.length + 1);
        // excel 下单不去查找价格
        if (!this.$route.query.type) {
          item.goodsInfo.specification.forEach((specificationItem) => {
            specificationItem.valueC.forEach((valueCItem, valueCIndex) => {
              item.detail.forEach((detailItem) => {
                if (
                  detailItem.key === specificationItem.keyC &&
                  detailItem.value === valueCItem.name
                ) {
                  specificationItem.active = valueCIndex;
                }
              });
            });
          });
        }
        setTimeout(() => {
          if (this.type === 'productManagementV2') {
            item.option = item.option || []
          } else if (this.optionList != false) {
            item.option = deepClone(this.optionList)
          } else if (item.option == undefined) {
            item.option = []
          }
          // item.option = deepClone(this.optionList != false ? this.optionList : item.option);
        }, 0);
        item.optionChecked = false;
        item.orderTagList = [];
        item.client_remark = item.client_remark ? item.client_remark : "";
        // 新入口补齐响应式备注字段，避免预览行缺字段时显示异常。
        if (this.type === 'productManagementV2') {
          this.$set(item, 'purchase_remark', item.purchase_remark || '')
          this.$set(item, 'inspect_remark', item.inspect_remark || '')
          this.$set(item, 'delivery_remark', item.delivery_remark || '')
          this.$set(item, 'y_remark', item.y_remark || '')
        }
        this.initMaterialState(item)
        this.orderDetail.push(item);
      });
      this.$refs.directAddition.dialogVisible = false;
      this.commodityTotal();
    },
    // 接收修改属性
    receiveAttributeEdit(data, pic) {

      this.orderDetail.forEach((item, index) => {
        if (index === this.i) {
          item[this.detailType] = data;
          if (pic) {
            item.pic = pic;
          }
          this.$forceUpdate();
        }
      });
      this.attributeDialogVisible = false;
      this.$forceUpdate();
      this.commodityTotal();
    },
    //更新备注栏
    updateClientRemark(e) {
      this.$forceUpdate();
    },
    //商品属性修改
    attributeEdit(item, i, type) {
      this.i = i;
      this.detailType = type
      this.itemDetail = {
        from_platform: item.fromPlatform ? item.fromPlatform : item.from_platform,
        goods_id: item.goodsId ? item.goodsId : item.goods_id,
        detail_y: item[type]
      };
      this.attributeDialogVisible = true;
    },
    //提出订单
    submitOrder() {
      if (this.orderDetail.length === 0) {
        //请至少添加一个商品
        this.$message.error(this.$t("message.pleaseAddAtLeastOneItem"));
        return;
      }
      if (!this.validateMaterialRelation()) return
      this.$api.clienteleApi
        .orderCreatePreview({ user_id: this.user_id })
        .then((res) => {
          let arr = [];
          this.orderDetail.forEach((item) => {

            arr.push({
              goods_id: item.goodsId ? item.goodsId : item.goods_id,
              goods_title: item.titleC ? item.titleC : item.goods_title,
              price: item.price,
              num: item.num,
              pic: item.pic,
              detail: JSON.stringify(item.detail),
              detail_y: JSON.stringify(item.detail_y),
              sku_id: item.sku_id,
              spec_id: item.specId ? item.specId : item.spec_id,
              shop_id: item.shopId ? item.shopId : item.shop_id,
              shop_name: item.shopName ? item.shopName : item.shop_name,
              from_platform: item.fromPlatform
                ? item.fromPlatform
                : item.from_platform,
              option: item.option.length > 0 ? JSON.stringify(item.option) : "[]",
              client_remark: item.client_remark,
              // 商品管理入口的三项要求随下单明细提交。
              ...(this.type === 'productManagementV2' ? {
                purchase_remark: item.purchase_remark,
                inspect_remark: item.inspect_remark,
                delivery_remark: item.delivery_remark
              } : {}),
              order_detail_tag: item.order_detail_tag,
              y_remark: item.y_remark,
              y_reply: item.y_reply,
              for_sn: this.type ? item.for_sn : [], //只有表格下单传
              is_material: item.is_material ? 1 : 0,
              material_id: item.material_id || '',
              material_bind: (item.material_list || []).map(material => ({
                material_id: material.material_id,
                consume: material.consume
              }))

            });
          });
          let data = {
            user_id: this.user_id,
            create_type: "send",
            order_sn: this.$route.query.order_sn ? this.$route.query.order_sn : res.data.order_sn,//有传定好用自己穿的，没有接口取
            client_remark: this.$refs.orderPrice.client_remark,
            logistics_id: this.$refs.orderPrice.value,
            order_file: this.$refs.orderPrice.fileList,
            order_detail: arr,
            y_remark: this.typeDetail != null ? this.typeDetail.y_remark : '',
            y_reply: this.typeDetail != null ? this.typeDetail.y_reply : ''
          };
          this.$api.clienteleApi.orderCreate(data).then((res) => {
            if (res.code != 0) {
              this.$message.error(res.msg);
              return;
            }
            setTimeout(() => {
              this.$message.success(res.msg);
              this.$router.push({
                path: "/user/orderList",
                query: {
                  userID: this.user_id,
                  status: "confirming",
                },
              });
            }, 1000);
          });
        });
    },
    // 选中商品数量总数、总价
    commodityTotal() {
      this.orderPriceInfo.goodsTotalPrice = 0;
      this.orderPriceInfo.goodsTotalYenPrice = 0;
      this.orderPriceInfo.RMBTotalPrice = 0;
      this.orderPriceInfo.yenTotalPrice = 0;
      this.orderPriceInfo.optionTotalPrice = 0;
      this.orderPriceInfo.goodsTotalNum = 0;
      this.orderPriceInfo.goodsTotalRmbPrice = 0;
      this.orderPriceInfo.serviceTotalNum = 0;

      this.orderSelectOptionList = [];
      this.orderDetail.forEach((item, i) => {
        let str = "";
        item.detail.forEach((detailItem) => {
          str += detailItem.value + "㊖㊎";
        });
        str = str.substr(0, str.length - 2);
        // 
        if (item.goodsInfo) {
          item.goodsInfo.goodsInventory.forEach((goodsInventoryItem) => {
            if (str === goodsInventoryItem.keyC) {
              goodsInventoryItem.valueC.forEach((valueItem) => {
                if (item.num >= valueItem.startQuantity) {
                  item.price = valueItem.price;
                }
              });
            }
          });
        }

        item.optionPrice = 0; //option 费用
        // 计算 options 费用
        if (item.option != null) {
          item.option.forEach((optionItem) => {
            if (
              optionItem.checked === true &&
              Number(optionItem.num) > 0 &&
              optionItem.price_type === 0
            ) {
              item.optionPrice += optionItem.num * optionItem.price;
              this.orderPriceInfo.optionTotalPrice +=
                optionItem.num * optionItem.price;
              optionItem.total = optionItem.num * optionItem.price;
              this.orderSelectOptionList.push(deepClone(optionItem));
            }
            if (
              optionItem.checked === true &&
              Number(optionItem.num) > 0 &&
              optionItem.price_type === 1
            ) {

              item.optionPrice +=
                item.num * Number(item.price) * (Number(optionItem.price) / 100);
              this.orderPriceInfo.optionTotalPrice += item.optionPrice - 0
              optionItem.total = item.num * Number(item.price) * (Number(optionItem.price) / 100);
              this.orderSelectOptionList.push(deepClone(optionItem));
            }
          });
        }


        this.orderPriceInfo.goodsTotalNum += item.num;
        // 商品手续费
        item.service_price = (((item.num *
          Number(item.price))) * item.service_rate).toFixed(2)
        this.orderPriceInfo.serviceTotalNum += item.service_price - 0
        //商品金额
        item.goodsTotal = (item.num * Number(item.price)).toFixed(2)
        // 商品总金额
        this.orderPriceInfo.goodsTotalRmbPrice += item.goodsTotal - 0
        // 小计
        item.total = ((item.goodsTotal - 0) + (item.service_price - 0) + (item.optionPrice - 0)).toFixed(2)
      });
      // 附加服务预览数据
      if (this.orderSelectOptionList.length > 0) {
        let end = [];
        end.push(deepClone(this.orderSelectOptionList[0]));
        end[0].num = Number(end[0].num);
        end[0].total = Number(end[0].total);
        for (let i = 1; i < this.orderSelectOptionList.length; i++) {
          this.orderSelectOptionList[i].num = Number(
            this.orderSelectOptionList[i].num
          );
          this.orderSelectOptionList[i].total = Number(
            this.orderSelectOptionList[i].total
          );
          let j = 0;
          for (; j < end.length; j++) {
            // 6. 判断两个数组中的id是否相同
            if (this.orderSelectOptionList[i].name === end[j].name) {
              // 7.相等就将我们比较的对象 `arr[i]` 存储到  相同id对象的list 中
              end[j].num += Number(this.orderSelectOptionList[i].num);
              end[j].total += Number(this.orderSelectOptionList[i].total);
              // *** 8.这里要理解，我们每次遍历，其实都是处理  `arr[i]` ，而上面的逻辑已经处理了，所以终止后续的循环 break;
              break;
            }
          }
          if (j === end.length) {
            end.push(this.orderSelectOptionList[i]);
          }
        }
        this.orderSelectOptionList = end;
      }
      // 商品金额 日元
      this.orderPriceInfo.goodsTotalYenPrice = (
        Number(this.orderPriceInfo.goodsTotalRmbPrice) * this.$store.state.rate
      ).toFixed(0);
      // console.log(this.orderPriceInfo.goodsTotalRmbPrice, this.orderPriceInfo.serviceTotalNum, this.orderPriceInfo.optionTotalPric);
      // 总金额 人民币
      this.orderPriceInfo.RMBTotalPrice = (
        Number(this.orderPriceInfo.goodsTotalRmbPrice) + Number(this.orderPriceInfo.serviceTotalNum) + Number(this.orderPriceInfo.optionTotalPrice)
      ).toFixed(2);
      // 总金额 日元
      this.orderPriceInfo.yenTotalPrice = (
        this.orderPriceInfo.RMBTotalPrice * this.$store.state.rate
      ).toFixed(0);

      // console.log(this.orderDetail);
    },
    //输入框取整
    numTrunc(item) {
      item.num = Math.trunc(item.num);
      if (Array.isArray(item.option)) {
        item.option.forEach((optionItem) => {
          if (Number(optionItem.price_type) === 0) {
            optionItem.num = item.num;
          }
        });
      }
      this.$forceUpdate();
      this.commodityTotal();
    },
    //输入框校验
    newChannelInputLimit(e) {
      let key = e.key;
      // 不允许输入'e'、'.'、'。'、'-'
      if (key === "e" || key === "." || key === "。" || key === "-") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    // option修改
    optionEdit(item, i) {
      this.i = i;
      this.itemDetail = item;
      this.optionsDialogVisible = true;
    },
    //禁止鼠标上下滚动
    stopScroll(evt) {
      evt = evt || window.event;
      if (evt.preventDefault) {
        // Firefox
        evt.preventDefault();
        evt.stopPropagation();
      } else {
        // IE
        evt.cancelBubble = true;
        evt.returnValue = false;
      }
      return false;
    },
    //url跳转
    openUrl(item) {
      if (item.from_platform == "1688") {
        window.open(
          `https://detail.1688.com/offer/${item.goods_id}.html?`,
          "_blank"
        );
      }
    },
    //编辑标签
    editTag(item, i) {
      if (item.order_detail_tag != false) {
        this.order_detail_tag = item.order_detail_tag[0]
      } else {
        this.order_detail_tag = {
          type: 'FBA', no: '', goods_no: '',
        }
      }
      // this.order_detail_tag = item.order_detail_tag
      this.i = i;
      this.tagDialogVisible = true
    },
    //追加商品库
    inventoryAddition() {
      this.commodityWarehouseDialogVisible = true;
    },
    //购物车追加
    shoppingCartAdd() {
      this.shoppingCartDialogVisible = true;
    },
  },
};
</script>
<style lang='scss' scoped>
.orderPreviewPage {
  background: #fff;
  padding: 0 24px 0 24px;

  .orderDetail {
    background: #f8f8f8;
    border-radius: 0 8px 8px 8px;
    margin-top: 24px;
    padding: 24px;

    .tabs {
      margin-bottom: 20px;
    }

    .table {
      font-size: 12px;

      ol {
        position: sticky;
        top: 0;
        left: 0;
        z-index: 9;
        display: flex;
        height: 40px;
        background: #edeff4;
        border-radius: 4px 4px 0 0;
        justify-content: center;
        align-items: center;

        li {
          height: 40px;
          text-align: center;
          align-items: center !important;
        }
      }

      li {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 5px;

        &:nth-last-child(1) {
          margin-right: 0;
        }
      }

      .flex05 {
        flex: 0.5;
      }

      .flex1 {
        flex: 1;
      }

      .flex2 {
        flex: 2;
      }

      .flex15 {
        flex: 1.5;
      }

      .noCell {
        position: relative;
        flex-direction: column;
        gap: 5px;

        .materialMarkTip {
          position: absolute;
          top: -10px;
          left: 0;
        }

        .noNumber {
          color: #606266;
          line-height: 18px;
        }

        .materialToggle {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 56px;
          height: 26px;
          padding: 0 8px;
          border: 0;
          border-radius: 4px;
          background-color: #f5f7fa;
          color: #606266;

          &:hover,
          &:focus {
            background-color: #ecf5ff;
            color: #409eff;
          }

          i {
            margin-left: 3px;
            font-size: 12px;
          }
        }
      }

      .productPreviewNoCell {
        .materialToggle {
          position: absolute;
          bottom: 4px;
          left: 50%;
          transform: translateX(-50%);
        }
      }

      // 两侧各占一半；辅料超宽时仅滚动左侧，不挤压右侧要求。
      .productPreviewDetails {
        display: flex;
        gap: 24px;
        min-width: 0;
        padding: 16px 20px;
        border-bottom: 1px solid #edeff4;
        background-color: #fff;
        box-sizing: border-box;
      }

      .productPreviewMaterial,
      .productPreviewRemarks {
        flex: 1 1 0;
        min-width: 0;
      }

      .productPreviewMaterial {
        /deep/ .material-info-panel {
          padding: 0;
          border: 0;
        }

        /deep/ .material-list {
          display: flex;
          overflow-x: auto;
          // 关闭图标超出卡片边缘，留出完整显示和滚动到末项的空间。
          padding: 10px 10px 8px 0;
        }

        /deep/ .material-card {
          flex: 0 0 288px;
        }

        /deep/ .empty {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 136px;
          padding: 0;
        }
      }

      .productPreviewRemarks {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 16px;
      }

      .remarkItem {
        display: flex;
        flex-direction: column;
        min-width: 0;

        label {
          display: block;
          margin-bottom: 10px;
          color: #333;
          font-size: 14px;
          font-weight: bold;
        }

        /deep/ .el-textarea {
          display: flex;
          flex: 1;
        }

        /deep/ .el-textarea__inner {
          flex: 1;
          min-height: 96px;
          height: auto;
        }
      }

      .important {
        background-color: #e0e7f7;
        max-height: 100px;
        overflow: hidden;
      }

      ul {
        display: flex;
        padding: 10px 0;
        border-bottom: 1px solid #edeff4;
        transition: all 0.3s;
        height: 100px;

        &:hover {
          background-color: #fff;
        }

        .template {
          text-align: center;

          p {
            margin-bottom: 5px;
          }
        }

        .attribute {
          text-align: left;
          width: 100%;
          height: 45px;
          overflow: hidden;

          .row {
            width: 100%;
            margin-bottom: 5px;
          }
        }

        .services {
          text-align: left;
        }

        .text {
          padding: 5px;
        }

        label {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        /deep/ .el-input__inner {
          padding: 0;
          text-align: center;
        }

        .pic {
          position: relative;
        }

        .edit {
          width: 20px;
          height: 20px;
          margin-left: 5px;

          i {
            font-size: 20px;
            color: #2c96e7;
            cursor: pointer;
          }
        }
      }
    }
  }

  .attributeEditContainer,
  .tagEditContainer {
    width: 100%;
    height: 60px;
    background: #ffffff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    .option {
      text-align: left;
      width: 100%;
      height: 60px;
      overflow: hidden;

      .row {
        width: 100%;
        margin-bottom: 0 !important;
      }
    }

    .tags {
      width: 100%;
      max-height: 80px;
      overflow-y: auto;
      position: relative;
      word-break: break-all;

      i {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(0, -50%);
      }
    }

    i {
      font-size: 20px;
      cursor: pointer;
    }
  }

  .orderChecked {
    /deep/ .el-checkbox__inner {
      transform: scale(1.5) !important;
    }
  }

  .clientRemark {
    /deep/ .el-textarea__inner {
      width: 240px;
      height: 80px;
    }
  }

  .subtotal {
    flex-direction: column;

    .detail {
      width: 48px;
      height: 24px;
      background: #2c96e7;
      border-radius: 4px;
      cursor: pointer;
      color: #fff;
      line-height: 24px;
      margin-top: 15px;
      text-align: center;
    }


    div {
      font-size: 14px;
    }
  }

  .tagEditContainer {
    height: 80px;
  }

  .operate {
    position: sticky;
    bottom: 0;
    left: 0;
    z-index: 9;
    min-height: 80px;
    height: auto;
    margin-top: 24px;
    padding: 12px 24px;
    background: #edeff4;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > .flexAndCenter:first-child {
      flex-wrap: wrap;
      gap: 8px;

      .el-button {
        margin-left: 0;
      }
    }

    .materialOperate {
      background-color: #14ad3c;
      border-color: #14ad3c;
    }

    .materialAction {
      display: inline-flex;

      .el-button.is-disabled {
        border-color: #c0c4cc !important;
        background-color: #c0c4cc !important;
        color: #ffffff !important;
        cursor: not-allowed;
      }
    }

    /deep/ .el-checkbox__inner {
      transform: scale(1.5) !important;
    }

    .goodsPriceText {
      color: #b4272d;
      font-weight: bold;
      font-size: 18px;
    }
  }
}
</style>
